<div class="row">
  <div class="lqd-column col-md-12 text-center">
    <h2 appTranslate="repatriate.title"></h2>
  </div>
</div>
<div class="row">
  <div class="lqd-column col-md-5">
    <p appTranslate="repatriate.text1"></p>
    <p appTranslate="repatriate.text2"></p>
  </div>

  <div class="lqd-column col-md-5 col-md-offset-2">
    <p appTranslate="repatriate.text3"></p>

    <div>
      <a [href]="contractUrl" target="_blank">
        <i antIcon type="file-pdf" theme="outline"></i>&nbsp;<span appTranslate="repatriate.readContract"></span>
      </a>
    </div>
    <div>
      <a [href]="termsUrl" target="_blank">
        <i antIcon type="file-pdf" theme="outline"></i>&nbsp;<span appTranslate="repatriate.termsManagement"></span>
      </a>
    </div>

    <form #formElement="ngForm" class="mt-3">
      <div class="mt-2">
        <app-checkbox-control [form]="formElement" [control]="acceptTheProcess"></app-checkbox-control>
      </div>

      <div class="mt-2">
        <app-checkbox-control [form]="formElement" [control]="acceptTerms"></app-checkbox-control>
      </div>

      <a (click)="next()" [class.disabled]="" class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2 mt-3 next">
        <span class="btn-txt" appTranslate="next"></span>
      </a>
    </form>
  </div>
</div>
